/**
 * @typedef {import('../tours/types.js').TourStep & {
 *   roles?: string[],
 *   capabilities?: string[],
 * }} PageTourStep
 */

/**
 * @typedef {{
 *   id: string,
 *   match: (pathname: string) => boolean,
 *   steps: PageTourStep[],
 * }} PageTourDefinition
 */

/** @type {PageTourDefinition[]} */
const PAGE_TOURS = [];

/**
 * @param {PageTourDefinition} def
 */
export function registerPageTour(def) {
  PAGE_TOURS.push(def);
}

/**
 * @param {string} pathname
 * @returns {PageTourDefinition | null}
 */
export function matchPageTour(pathname) {
  const path = pathname.split('?')[0];
  for (const def of PAGE_TOURS) {
    if (def.match(path)) {
      return def;
    }
  }
  return null;
}

export function allPageTourIds() {
  return PAGE_TOURS.map((d) => d.id);
}
